<template>
  <div>
    <b-dropdown class="dropdown-mega d-lg-block ml-0" toggle-class="header-data" menu-class="dropdown-megamenu" variant="black">
      <template v-if="selected" v-slot:button-content>
        <div class="selector-wrapper">
          <div class="row " :class="variant == 'white' ? 'text-white' : 'text-primary'">
            <div class="col-xs-6">
              <img v-if="selected && selected.logo" class="rounded-circle header-profile-user" :src="`${selected.logo}`" />
            </div>

            <div style=" margin-left: 10px;">
              <b class="font-size-18">{{ selected.name }}</b
              ><br />
              <p class="text-muted">
                <i class="mdi mdi-hexagon-multiple-outline"></i>
                {{ selected.workspace.name }}
              </p>
            </div>

            <div class="col-xs-6 text-muted pt-2 pl-2">
              <i class="bx bx-chevron-down font-size-20"></i>
            </div>
          </div>
        </div>
      </template>

      <b-row>
        <b-col class="col-md-4 p-4">
          <div v-if="selected" class="d-flex flex-col justify-content-cente align-items-center">
            <div style="width: max-content;">
              <div class="d-flex">
                <img :src="selected.logo" class="rounded-circle mr-3" style="width: 100px; height: 100px; border: 2px solid #ccc;" />
                <div class="mt-3">
                  <h4>{{ selected.name }}</h4>
                  <span>
                    <i class="mdi mdi-hexagon-multiple-outline"></i>
                    {{ selected.workspace.name }}
                  </span>
                </div>
              </div>
              <h5 class="mt-3 mb-2">
                {{ $t("organization.organization-by-roles") }}
              </h5>
              <div v-for="role in selected.roles" :key="selected._id + role._id" class="mb-1">
                <span class="badge badge-light border border-secondary p-1 ml-1">
                  {{ role.name | translate }}
                </span>
              </div>
            </div>
          </div>
        </b-col>

        <b-col class="col-md-8">
          <div class="text-center">
            <h3 class="mb-4">{{ $t("organization.all") }}</h3>
          </div>

          <organization-list :hideCreateButton="true" @setSelected="setSelected" />
        </b-col>
      </b-row>
    </b-dropdown>
  </div>
</template>

<script>
import OrganizationList from "@/modules/core/organization/organization-view";

export default {
  components: { OrganizationList },
  props: ["variant"],
  computed: {
    selected() {
      return this.$store.getters["organization/selected"];
    },
  },

  methods: {
    setSelected(data) {
      this.$store.dispatch("organization/selected", data);
      this.$store.commit("switchWorkspace/selected", data?.workspace);
      window.location.reload();
    },
  },
};
</script>

<style scoped>
.text-muted {
  color: #939393 !important;
}

.card.border-gray {
  border-color: #d4d4d4 !important;
}

.selector-wrapper {
  padding: 23px;
}
</style>
